import { GridCellKind } from '@glideapps/glide-data-grid';
import type { CustomCell, CustomRenderer } from '@glideapps/glide-data-grid';
import { type Chip, type ChipsLayout, paintChips } from './chipPainting.js';

export interface ChipsCellData extends ChipsLayout {
  readonly kind: 'chips';
  readonly chips: readonly Chip[];
}

export type ChipsCell = CustomCell<ChipsCellData>;

/**
 * Who knows whom, coloured by warmth. Read-only in the grid on purpose: a
 * relationship is a row of its own, edited in the side panel, not free text
 * typed back into a cell.
 */
export const chipsRenderer: CustomRenderer<ChipsCell> = {
  kind: GridCellKind.Custom,
  isMatch: (cell: CustomCell): cell is ChipsCell =>
    'kind' in cell.data && cell.data.kind === 'chips',
  draw: (args, cell) => {
    paintChips(args, cell.data.chips, { note: cell.data.note });
  },
};

export function chipsCell(chips: readonly Chip[], layout: ChipsLayout = {}): ChipsCell {
  return {
    kind: GridCellKind.Custom,
    allowOverlay: false,
    copyData: [...chips.map((chip) => chip.label), layout.note ?? '']
      .filter((part) => part !== '')
      .join(', '),
    data: { kind: 'chips', chips, note: layout.note },
  };
}
